import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import BasicDialog from "../../base/BasicDialog";
import { Button, Grid } from "@mui/material";
import { isEmptyValue } from "../../../helpers/methods";
import { useForm } from "../../../hooks/useForm";
import DateField from "../../field/DateField/DateField";
import FloatField from "../../base/FloatField";

const InsertNewTrancheDialog = (props) => {
  const { t } = useTranslation();

  const {
    formValue,
    onChange,
    onChangeDate
  } = useForm({ selectedDate: props.initDate });


  return (
    <BasicDialog
      open={props.open}
      onClose={props.onClose}
      titleAlign="center"
      maxWidth="xs"
      title={t("dialog.insert_new_tranche_dialog.add_tranche_rate")}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid item xs={12}>
          <DateField
            name="selectedDate"
            label={t("dialog.insert_new_tranche_dialog.selected_date")}
            value={formValue?.selectedDate}
            onChange={onChangeDate}
            required
            minDate={props.minDate}
            maxDate={props.maxDate}
          />
        </Grid>
        <Grid item xs={12}>
          <FloatField
            name="tranche_value"
            label={t("dialog.insert_new_tranche_dialog.tranche_value")}
            value={formValue?.tranche_value}
            onChange={onChange}
            required
            decimalPlaces={2}
            min={0}
            showNumberSeparator
            suffix={props.selectedCurrency}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            sx={{ marginTop: "20px" }}
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => props.onSubmit([formValue.selectedDate, formValue.tranche_value])}
            disabled={isEmptyValue(formValue?.selectedDate) || isEmptyValue(formValue?.tranche_value)}
          >
            {t("add")}
          </Button>
        </Grid>
      </Grid>
    </BasicDialog>
  );
};

InsertNewTrancheDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  initDate: PropTypes.string,
  selectedCurrency : PropTypes.string,
};

InsertNewTrancheDialog.defaultProps = {
  open: false,
  selectedCurrency : ''
};

export default InsertNewTrancheDialog;
